import { useNavigate } from "react-router-dom";
import SEO from "../components/seo/SEO";
import { Section, Fade, Heading, Label, Text, Button, C } from "../components/ui";

export default function About() {
  const navigate = useNavigate();

  const goToContact = () => {
    navigate("/contact");
  };

  const team = [
    {
      name: "Your Name",
      role: "Founder & Lead Strategist",
      desc: "10+ years helping local businesses grow through digital marketing.",
    },
    {
      name: "Team Member",
      role: "Content Creator",
      desc: "Expert in short-form video and social media content that converts.",
    },
    {
      name: "Team Member",
      role: "Web Developer",
      desc: "Building high-converting websites and funnels for local businesses.",
    },
  ];

  const values = [
    {
      icon: "🎯",
      title: "Results-First",
      desc: "We don't do vanity metrics. Every strategy we implement is designed to drive real business outcomes.",
    },
    {
      icon: "💪",
      title: "Local Experts",
      desc: "We understand Canadian markets and what works for local businesses coast to coast.",
    },
    {
      icon: "🤝",
      title: "Partnership",
      desc: "We see our clients as partners. Your success is our success.",
    },
    {
      icon: "📊",
      title: "Transparent",
      desc: "Clear reporting, honest feedback, and no jargon. You'll always know what we're doing.",
    },
  ];

  return (
    <>
      <SEO
        title="About Us"
        description="Learn about RevSpike - the digital marketing agency helping local businesses across Canada grow with done-for-you marketing services."
      />

      {/* Hero Section */}
      <Section background={C.navy}>
        <Fade>
          <div style={{ textAlign: "center", maxWidth: "800px", margin: "0 auto" }}>
            <Label light>About Us</Label>
            <Heading light style={{ marginBottom: "24px" }}>
              We Help Local Businesses Win
            </Heading>
            <Text light size="lg" style={{ marginBottom: "40px" }}>
              RevSpike is a digital growth agency built for local businesses. We combine
              strategy, creativity, and data to deliver real results — not just vanity metrics.
            </Text>
            <Button variant="coral" onClick={goToContact}>
              Work With Us
            </Button>
          </div>
        </Fade>
      </Section>

      {/* Mission Section */}
      <Section background={C.offWhite}>
        <Fade>
          <div style={{ textAlign: "center", maxWidth: "700px", margin: "0 auto" }}>
            <Label>Our Mission</Label>
            <Heading size={2} style={{ marginBottom: "24px" }}>
              Level the Playing Field for Local Businesses
            </Heading>
            <Text size="lg" style={{ color: C.gray600 }}>
              Big companies have big marketing teams. Local businesses deserve the same advantage.
              We provide enterprise-level marketing services at prices local businesses can actually afford.
            </Text>
          </div>
        </Fade>
      </Section>

      {/* Values Section */}
      <Section background={C.white}>
        <Fade>
          <div style={{ textAlign: "center", marginBottom: "60px" }}>
            <Label>Our Values</Label>
            <Heading size={2}>What We Stand For</Heading>
          </div>
        </Fade>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
            gap: "32px",
          }}
        >
          {values.map((value, index) => (
            <Fade key={index} delay={index * 0.1}>
              <div
                style={{
                  background: C.gray50,
                  padding: "32px",
                  borderRadius: "12px",
                  textAlign: "center",
                }}
              >
                <div style={{ fontSize: "3rem", marginBottom: "16px" }}>{value.icon}</div>
                <Heading size={3} style={{ marginBottom: "12px" }}>
                  {value.title}
                </Heading>
                <Text size="sm" style={{ color: C.gray600 }}>
                  {value.desc}
                </Text>
              </div>
            </Fade>
          ))}
        </div>
      </Section>

      {/* Team Section */}
      <Section background={C.offWhite}>
        <Fade>
          <div style={{ textAlign: "center", marginBottom: "60px" }}>
            <Label>Our Team</Label>
            <Heading size={2}>The People Behind Your Growth</Heading>
          </div>
        </Fade>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
            gap: "32px",
          }}
        >
          {team.map((member, index) => (
            <Fade key={index} delay={index * 0.1}>
              <div
                style={{
                  background: C.white,
                  padding: "32px",
                  borderRadius: "12px",
                  textAlign: "center",
                  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.06)",
                }}
              >
                <div
                  style={{
                    width: "100px",
                    height: "100px",
                    background: C.gray100,
                    borderRadius: "50%",
                    margin: "0 auto 20px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "2rem",
                  }}
                >
                  👤
                </div>
                <Heading size={3} style={{ marginBottom: "8px" }}>
                  {member.name}
                </Heading>
                <Text
                  size="sm"
                  style={{
                    color: C.coral,
                    fontWeight: 600,
                    marginBottom: "12px",
                    textTransform: "uppercase",
                    letterSpacing: "0.05em",
                  }}
                >
                  {member.role}
                </Text>
                <Text size="sm" style={{ color: C.gray600 }}>
                  {member.desc}
                </Text>
              </div>
            </Fade>
          ))}
        </div>
      </Section>

      {/* CTA Section */}
      <Section background={C.navyLight}>
        <Fade>
          <div style={{ textAlign: "center", maxWidth: "700px", margin: "0 auto" }}>
            <Heading light style={{ marginBottom: "24px" }}>
              Ready to Grow Your Business?
            </Heading>
            <Text light size="lg" style={{ marginBottom: "40px" }}>
              Let's discuss how we can help you reach more customers and dominate your local market.
            </Text>
            <Button variant="coral" size="lg" onClick={goToContact}>
              Get Your Free Strategy Call
            </Button>
          </div>
        </Fade>
      </Section>
    </>
  );
}
